import React from 'react';
import c from '../w.js';

const IconFileImage = React.memo(
  c(
    /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("path", { d: "M8.99999 7C8.99999 8.10457 8.10456 9 6.99999 9C5.89542 9 4.99999 8.10457 4.99999 7C4.99999 5.89543 5.89542 5 6.99999 5C8.10456 5 8.99999 5.89543 8.99999 7Z" }), /* @__PURE__ */ React.createElement("path", { d: "M7.76821 13.9219C7.36841 13.4421 6.63156 13.4421 6.23177 13.9219L3.36681 17.3598C2.82404 18.0111 3.28719 19 4.13503 19H20.0793C20.8884 19 21.3625 18.0893 20.8986 17.4265L15.8192 10.1703C15.4211 9.60162 14.5789 9.60161 14.1808 10.1703L10.5762 15.3197C10.1983 15.8596 9.41059 15.8927 8.98871 15.3865L7.76821 13.9219Z" }))
  )
);

export { IconFileImage };
